const DB_NAME = 'blockzie-custom-assets';
const DB_VERSION = 1;
const STORE_NAME = 'assets';

export const CUSTOM_ASSET_TYPES = {
  BACKGROUND: 'background',
  SPRITE: 'sprite',
};

const canUseIndexedDb = () => typeof window !== 'undefined' && 'indexedDB' in window;

const openDb = () => new Promise((resolve, reject) => {
  if (!canUseIndexedDb()) {
    resolve(null);
    return;
  }

  const request = indexedDB.open(DB_NAME, DB_VERSION);
  request.onupgradeneeded = () => {
    const db = request.result;
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      const store = db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      store.createIndex('type', 'type', { unique: false });
    }
  };
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

const runStoreRequest = async (mode, runner) => {
  const db = await openDb();
  if (!db) return null;

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, mode);
    const store = tx.objectStore(STORE_NAME);
    const request = runner(store);

    tx.oncomplete = () => db.close();
    tx.onabort = () => db.close();
    tx.onerror = () => db.close();

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

export const loadCustomAssets = async () => {
  if (!canUseIndexedDb()) return { backgrounds: [], sprites: [] };

  try {
    const allAssets = await runStoreRequest('readonly', (store) => store.getAll());
    const assets = Array.isArray(allAssets) ? allAssets : [];
    const sortByCreated = (a, b) => (b.createdAt || 0) - (a.createdAt || 0);

    return {
      backgrounds: assets.filter(a => a.type === CUSTOM_ASSET_TYPES.BACKGROUND).sort(sortByCreated),
      sprites: assets.filter(a => a.type === CUSTOM_ASSET_TYPES.SPRITE).sort(sortByCreated),
    };
  } catch (err) {
    console.warn('Custom asset load failed:', err);
    return { backgrounds: [], sprites: [] };
  }
};

export const saveCustomAsset = async (asset) => {
  if (!asset || !asset.id || !canUseIndexedDb()) return null;

  try {
    await runStoreRequest('readwrite', (store) => store.put(asset));
    return asset;
  } catch (err) {
    console.warn('Custom asset save failed:', err);
    return null;
  }
};

export const deleteCustomAsset = async (assetId) => {
  if (!assetId || !canUseIndexedDb()) return false;

  try {
    await runStoreRequest('readwrite', (store) => store.delete(assetId));
    return true;
  } catch (err) {
    console.warn('Custom asset delete failed:', err);
    return false;
  }
};
